<template>
  <form>
    <div id="div-dietary-diagnostic-create-form" class="vs-con-loading__container">
      <vx-card title="Search" title-color="primary">
        <vs-row>
          <vs-col vs-type="flex" vs-align="center" vs-lg="3" vs-sm="12" vs-xs="12">
            <vs-input v-model="data.search" label-placeholder="Procure pelo nome..." class="mt-5 w-full" />
          </vs-col>
        </vs-row>

        <br />

        <vs-row>
          <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
            <ul>
              <div class="card" v-for="diagnostic in filteredList" v-bind:key="diagnostic.id">
                <div
                  v-if="diagnostic.idDietaryDiagnosticCategory == $props.idDietaryDiagnosticCategory && diagnostic.alwaysShow == false"
                >
                  <li>
                    <vs-checkbox
                      :checked="data.dietaryDiagnosticsSelected.filter(e => e.idDietaryDiagnostic === diagnostic.id).length > 0"
                      class="inline-flex"
                      v-model="data.dietaryDiagnosticsSelected"
                      :vs-value="{ id: diagnostic.id, value: null }"
                    >{{ diagnostic.name }}</vs-checkbox>
                  </li>
                </div>
              </div>
            </ul>
          </vs-col>
        </vs-row>

        <br />

        <vs-row>
          <vs-col vs-type="flex" vs-align="right" vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-button @click="submit">Enviar</vs-button>
          </vs-col>
        </vs-row>
      </vx-card>
    </div>
  </form>
</template>

<script>
// import { Validator } from 'vee-validate';

// Service
// import DietaryDiagnosticService from "../../../../services/DietaryDiagnosticService";

export default {
  components: {},
  props: {
    idDietaryDiagnosticCategory: {
      required: true
    },
    dietaryDiagnostics: {
      required: true
    }
  },
  data() {
    return {
      data: {
        search: "",
        dietaryDiagnosticsSelected: []
      },
    };
  },
  computed: {
    filteredList() {
      return this.$props.dietaryDiagnostics.filter(dietary => {
        return dietary.name
          .toLowerCase()
          .includes(this.data.search.toLowerCase());
      });
    }
  },
  methods: {
    async submit() {
      this.$emit("DietaryDiagnosticSelect_submit", this.data.dietaryDiagnosticsSelected);
    },
  }
};
</script>